var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 183,
    viewBox: "0 0 209 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.49 144.253C105.456 144.253 106.223 143.488 106.223 142.524C106.223 141.559 105.456 140.794 104.49 140.794C103.523 140.794 102.757 141.559 102.757 142.524C102.757 143.488 103.523 144.253 104.49 144.253Z",
    fill: "#CFCFCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0255 13.8367V21.4535",
    stroke: "#BABABA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1923 17.6284H57.8252",
    stroke: "#BABABA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.755 61.7658C125.922 61.7658 110.823 61.1671 96.7235 57.2423C82.8574 53.4173 70.158 45.9668 58.7919 37.3522C51.3922 31.7643 44.6259 27.2741 34.993 27.9393C25.5601 28.4382 16.5606 31.9639 9.26089 37.9509C-3.0052 48.6942 -1.13862 68.551 3.76115 82.4542C11.1275 103.442 33.5597 118.077 52.6255 127.523C74.6578 138.499 98.8567 144.885 123.122 148.544C144.388 151.77 171.72 154.098 190.119 140.262C207.052 127.523 211.685 98.4527 207.552 78.8287C206.552 73.0413 203.452 67.786 198.852 64.1273C186.953 55.4462 169.22 61.2336 155.854 61.533C150.888 61.5995 145.821 61.7325 140.755 61.7658Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.789 3.45915C117.756 3.45915 118.522 2.69415 118.522 1.72957C118.522 0.765004 117.756 0 116.789 0C115.822 0 115.056 0.765004 115.056 1.72957C115.022 2.69415 115.822 3.45915 116.789 3.45915Z",
    fill: "#CFCFCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5601 138.366V145.983",
    stroke: "#BABABA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7603 142.191H30.3932",
    stroke: "#BABABA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.19 182.936C141.121 182.936 170.22 181.14 170.22 178.878C170.22 176.616 141.088 174.82 105.19 174.82C69.2581 174.82 40.1595 176.616 40.1595 178.878C40.1595 181.14 69.2581 182.936 105.19 182.936Z",
    fill: "#F2F2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.487 135.506H45.1259C44.3592 135.506 43.6259 135.339 42.9593 135.04C42.2927 134.741 41.6594 134.275 41.1927 133.709C40.6927 133.144 40.3594 132.479 40.1594 131.747C39.9594 131.015 39.9261 130.284 40.0261 129.519L54.3921 42.5742C54.5921 41.3768 55.1921 40.2792 56.1587 39.4809C57.092 38.6826 58.2919 38.2502 59.5252 38.2502H171.887C172.653 38.2502 173.387 38.4165 174.053 38.7159C174.72 39.0152 175.353 39.4809 175.82 40.0463C176.32 40.6118 176.653 41.277 176.853 42.0087C177.053 42.7405 177.086 43.5055 176.953 44.2372L162.654 131.182C162.454 132.412 161.82 133.51 160.887 134.308C159.92 135.106 158.721 135.539 157.487 135.506Z",
    fill: "#D2D2D2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.854 35.9553L92.157 6.25313C90.1904 5.38834 87.8905 6.25313 87.0239 8.21553L65.8915 55.4462C65.0249 57.4086 65.8915 59.7036 67.8581 60.5684L134.555 90.2706C136.522 91.1353 138.821 90.2706 139.688 88.3082L160.82 41.0775C161.72 39.1151 160.82 36.82 158.854 35.9553Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.957 45.1019C103.723 42.6406 106.256 40.8777 109.19 40.0795C112.123 39.2812 115.223 39.514 117.989 40.7447C120.756 41.9754 122.989 44.1041 124.355 46.7982C125.722 49.4923 126.089 52.5856 125.455 55.5126",
    stroke: "#BABABA",
    strokeWidth: 3.6146,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M133.822 42.4412C134.822 42.4412 135.655 41.6097 135.655 40.6118C135.655 39.614 134.822 38.7825 133.822 38.7825C132.822 38.7825 131.988 39.614 131.988 40.6118C132.022 41.6097 132.822 42.4412 133.822 42.4412Z",
    fill: "#BABABA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M107.39 30.6668C108.39 30.6668 109.223 29.8352 109.223 28.8374C109.223 27.8396 108.39 27.0081 107.39 27.0081C106.39 27.0081 105.556 27.8396 105.556 28.8374C105.59 29.8352 106.39 30.6668 107.39 30.6668Z",
    fill: "#BABABA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M156.987 135.472H44.0926C42.726 135.472 41.3927 134.907 40.4261 133.942C39.4595 132.978 38.9261 131.647 38.9261 130.284V50.8562C38.9261 50.1577 39.0261 49.4925 39.2928 48.8273C39.5595 48.1953 39.9261 47.5966 40.3927 47.0977C40.8594 46.5988 41.4594 46.1996 42.0927 45.9336C42.726 45.6675 43.4259 45.5344 44.0926 45.5344H85.224C86.1906 45.5344 87.1239 45.8005 87.9238 46.2994C88.7238 46.7983 89.3904 47.4968 89.8238 48.3616L95.6902 59.8034C96.1235 60.6682 96.7901 61.3667 97.5901 61.8656C98.39 62.3645 99.3233 62.6306 100.29 62.6306H156.987C158.354 62.6306 159.687 63.1628 160.654 64.1274C161.62 65.0919 162.154 66.4224 162.154 67.7861V130.25C162.154 131.614 161.62 132.944 160.654 133.909C159.654 134.94 158.354 135.472 156.987 135.472Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M139.588 65.3911C133.055 65.3911 126.689 67.3203 121.256 70.9124C115.823 74.5379 111.589 79.6601 109.09 85.6804C106.59 91.7006 105.923 98.3196 107.19 104.706C108.456 111.092 111.589 116.946 116.223 121.569C120.822 126.159 126.722 129.319 133.122 130.583C139.521 131.847 146.154 131.215 152.188 128.72C158.221 126.226 163.354 122.001 166.987 116.613C170.62 111.192 172.553 104.839 172.553 98.3196C172.553 89.6052 169.087 81.2234 162.887 75.0701C156.721 68.8503 148.321 65.3911 139.588 65.3911Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M163.054 122.168L171.853 130.949",
    stroke: "#BABABA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M170.853 126.658L168.12 129.518C166.887 130.782 166.953 132.811 168.22 134.042L191.919 156.66C193.186 157.89 195.219 157.824 196.452 156.56L199.185 153.699C200.419 152.435 200.352 150.406 199.085 149.176L175.386 126.558C174.086 125.328 172.087 125.394 170.853 126.658Z",
    fill: "#D2D2D2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M188.386 1.72949V9.34627",
    stroke: "#BABABA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M184.553 5.55469H192.186",
    stroke: "#BABABA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.f86368222359fdbd7fe302357caec3f9.svg";
export { ForwardRef as ReactComponent };